import { createContext, useContext } from 'react';

/**
 * The snap-prefix string is constant for the lifetime of a
 * `CommandPaletteProvider`. We thread it through a tiny context so the
 * parser, search field pill, and discoverability hint all read the same
 * value without prop-drilling. Default is `@`.
 *
 * Callers can pick any non-empty string. Common choices:
 *
 *   - `'@'`  -- compact, Slack/ChatGPT-flavoured (default)
 *   - `'>'`  -- terminal-y; works well if the palette is positioned as a
 *              command prompt
 *   - `'in:'` -- explicit, search-engine-flavoured (Gmail/Github)
 */
export const SnapPrefixContext = createContext<string>('@');

export function useSnapPrefix(): string {
  return useContext(SnapPrefixContext);
}
